/*
Author: Hoi Tak Leung
Email: hoi.leung@greedy.mx
Last Update: 25/09/2023
*/

import { Typography, Container, CssBaseline, Grid, Box } from "@mui/material";

import ImgDefinition from "../../../assets/greedy_definition.webp";
import ImgDefinitionEnglish from "../../../assets/greedy_definition_english.webp";

import "./AboutSection.css";
import { useScrollReveal } from "../../../helpers/ScrollReveal";
import { useLanguageContext } from "../../../context/languageContext";
import { textlanguages } from "../../../data/textOfThePage";
import { useLocation } from "react-router-dom";

export default function AboutSection() {
  const { languageSelected } = useLanguageContext();
  const location = useLocation();
  useScrollReveal([
    {
      selector: ".revealFromrightAboutUs",
      options: {
        distance: "300px",
        duration: 1000,
        easing: "ease-out",
        origin: "right",
        reset: false,
        viewFactor: 0.8,
      },
    },
    {
      selector: ".revealFromLeftAboutUs",
      options: {
        distance: "300px",
        duration: 1000,
        easing: "ease-out",
        origin: "left",
        reset: false,
        viewFactor: 0.1,
      },
    },
  ]);
  return (
    <Container
      disableGutters
      maxWidth={false}
      className="container-section-about"
      sx={{ overflowX: "hidden" }}
    >
      <CssBaseline />
      <Grid container sx={{ overflowX: "hidden", display: "flex" }}>
        <Grid
          item
          container
          xs={12}
          lg={6}
          xl={6}
          className="section-about-grid"
          sx={{
            order: { xs: 0, md: 0, lg: 1 },
            overflowX: "hidden",
          }}
        >
          <Grid item xs={1}></Grid>
          <Grid item xs={10} sx={{ margin: "auto", overflowX: "hidden" }}>
            <Box className="section-about-box" sx={{ overflowX: "hidden" }}>
              <Typography
                variant="h3"
                className="section-about-header revealFromrightAboutUs"
                sx={{ overflowX: "hidden" }}
              >
                {textlanguages[languageSelected].aboutUs.title}
              </Typography>
              <Typography
                variant="h5"
                className="section-about-description revealFromrightAboutUs"
                sx={{ overflowX: "hidden" }}
              >
                {textlanguages[languageSelected].aboutUs.description}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>
        <Grid
          item
          xs={12}
          lg={6}
          xl={6}
          sx={{ order: { xs: 1, md: 1, lg: 0 } }}
        >
          <img
            src={
              languageSelected === 0 || languageSelected === "0"
                ? ImgDefinition
                : ImgDefinitionEnglish
            }
            className="img-greedy-definition"
            alt="Definición Greedy"
            style={{
              height: location.pathname === "/about-us" ? "100%" : "99%",
            }}
          />
        </Grid>
      </Grid>
    </Container>
  );
}
